@if (enableAllocations) {
    <div class="card panel-flat-color secondary-panel">
        <div class="panel-flat-header pointer" (click)="expandOrCollapse()" [ngClass]="{'pointer': !isMaximized}">
            @if (!isMaximized) {
                <panel-chevron [showBody]="showBody"></panel-chevron>
            }
            <h3>Responsible Entities</h3>
            <div class="float-end header-button-container">
                @if (showBody && !isMaximized) {
                    <button type="button"
                            class="ace-btn has-icon btn-text btn-secondary"
                            style="margin-right: -1px;"
                            (click)="maximize($event)">
                        <i class="fa fa-arrows-alt"></i>
                    </button>
                }
                @if (showBody && isMaximized) {
                    <button type="button" class="ace-btn has-icon btn-text btn-secondary"
                            style="margin-right: -1px;"
                            (click)="unmaximize($event)">
                        <i class="fa fa-compress"></i>
                    </button>
                }
            </div>
        </div>
        @if (showBody) {
            <div class="card-body" style="padding-top: 0;height: 490px;">
                @if (loading) {
                    <div class="text-center" style="margin-top: 50px;">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                    </div>
                }
                <div [hidden]="loading" class="ws-flex-container-horizontal ws-stretch ws-overflow-auto">
                    <responsible-entity-list [companyId]="companyId"
                                             [siteId]="siteId"
                                             [parcelId]="parcelId"
                                             (loading)="onLoadingChanged($event)"></responsible-entity-list>
                </div>
            </div>
        }
    </div>
}
